import { render, staticRenderFns } from "./PsList.vue?vue&type=template&id=dafebd26&scoped=true&"
import script from "./PsList.vue?vue&type=script&lang=js&"
export * from "./PsList.vue?vue&type=script&lang=js&"
import style0 from "./PsList.vue?vue&type=style&index=0&id=dafebd26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dafebd26",
  null
  
)

export default component.exports